import { useMutation } from '@apollo/client';
import type { DefaultContext, FetchResult, MutationFunctionOptions } from '@apollo/client';

import type {
  DeleteHangingProtocolMutation,
  DeleteHangingProtocolMutationVariables,
} from 'generated/graphql';

import { DELETE_HANGING_PROTOCOL, GET_ALL_HANGING_PROTOCOLS } from 'modules/Apollo/queries';
import { WithApolloContext } from 'modules/Apollo/types';

export const useDeleteHangingProtocol = ({
  context,
}: WithApolloContext): ((
  options?: MutationFunctionOptions<
    DeleteHangingProtocolMutation,
    DeleteHangingProtocolMutationVariables,
    DefaultContext
  >
) => Promise<FetchResult<DeleteHangingProtocolMutation>>) => {
  const [deleteHangingProtocol] = useMutation<
    DeleteHangingProtocolMutation,
    DeleteHangingProtocolMutationVariables
  >(DELETE_HANGING_PROTOCOL, {
    refetchQueries: [{ query: GET_ALL_HANGING_PROTOCOLS }],
    awaitRefetchQueries: true,
    context,
  });
  return deleteHangingProtocol;
};
